var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loading)?_c('div',{staticClass:"fill-height d-flex align-center justify-center"},[_c('Loading')],1):_c('v-main',[(_vm.$route.name === 'Home')?_c('Popups'):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }